import { Grid, Typography } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { TConfigCCOTitulosReceber } from '../../../../../../../types/api/financeiro/conta-corrente-consumo-configuracoes'
import SelectTipoDocReceber from '../../../../../../../components/SelectsSimpleApiQuery/SelectTipoDocReceber'
import { useMemo } from 'react'
import SelectLocaisCobranca from '../../../../../../../components/SelectsSimpleApiQuery/SelectLocaisCobranca'
import SelectCategoria from '../../../../../../../components/SelectsSimpleApiQuery/SelectCategoria'
import SelectLojaComPesquisa from '../../../../../../../components/SelectsSimpleApiQuery/SelectLojaComPesquisa'
import SelectFuncoes from '../../../../../../../components/SelectsSimpleApiQuery/SelectFuncao'
import SelectSituacaoFinanceira from '../../../../../../../components/SelectsSimpleApiQuery/SelectSituacaoFinanceira'
import MultipleDatePicker from '../../../../../../../components/MultipleDataPicker'
import moment, { Moment } from 'moment'
export default function CCOGerarTitulosReceberConfig() {

    const { setValue, watch, control } = useFormContext()

    const titulosReceberParams: TConfigCCOTitulosReceber | null = watch('config_geracao_titulo_receber')

    const valueDiasVencimento = useMemo(() => {
        return titulosReceberParams?.dias_vencimento
    }, [titulosReceberParams?.dias_vencimento])

    return (
        <>
            <Typography mt={1} mb={2}><b>Configuração de geração de títulos a receber</b></Typography>
            <Grid container spacing={2}>
                <Grid size={{xs: 6}}>
                    <Controller
                        name='config_geracao_titulo_receber.tipo_documento'
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => {
                            return (
                                <SelectTipoDocReceber
                                    {...field}
                                    required
                                    error={invalid}
                                    value={field.value}
                                    onChange={(valor) => field.onChange(valor)}
                                />
                            )
                        }}
                    />
                </Grid>
                <Grid size={{xs: 6}}>
                    <Controller
                        name='config_geracao_titulo_receber.local_cobranca'
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => {
                            return (
                                <SelectLocaisCobranca
                                    {...field}
                                    required
                                    error={invalid}
                                    value={field.value}
                                    onChange={(valor) => field.onChange(valor)}
                                />
                            )
                        }}
                    />
                </Grid>
                <Grid size={{xs: 6}}>
                    <Controller
                        name='config_geracao_titulo_receber.categoria'
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => {
                            return (
                                <SelectCategoria
                                    {...field}
                                    required
                                    error={invalid}
                                    value={field.value}
                                    onChange={(valor) => field.onChange(valor)}
                                />
                            )
                        }}
                    />
                </Grid>
                <Grid size={{xs: 6}}>
                    <Controller
                        name='config_geracao_titulo_receber.loja'
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => {
                            return (
                                <SelectLojaComPesquisa
                                    {...field}
                                    required
                                    error={invalid}
                                    value={field.value}
                                    onChange={(valor) => {field.onChange(valor)}}
                                />
                            )
                        }}
                    />
                </Grid>
                <Grid size={{xs: 6}}>
                    <Controller
                        name='config_geracao_titulo_receber.funcao'
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => {
                            return (
                                <SelectFuncoes
                                    {...field}
                                    required
                                    error={invalid}
                                    value={field.value}
                                    onChange={(valor) => field.onChange(valor)}
                                />
                            )
                        }}
                    />
                </Grid>
                <Grid size={{xs: 6}}>
                    <Controller
                        name='config_geracao_titulo_receber.situacao'
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => {
                            return (
                                <SelectSituacaoFinanceira
                                    {...field}
                                    required
                                    error={invalid}
                                    value={field.value}
                                    onChange={(valor) => field.onChange(valor)}
                                />
                            )
                        }}
                    />
                </Grid>
                <Grid size={{xs: 6}}>
                    <MultipleDatePicker
                        required
                        blockPastDates
                        label="Dias do vencimento"
                        value={valueDiasVencimento
                            ? valueDiasVencimento.map(day =>
                                moment().set('date', day)
                            )
                            : []
                        }
                        formatString="DD"
                        onChange={(data: Moment[] | null) => { setValue('config_geracao_titulo_receber.dias_vencimento', data?.map(item => Number(item.format('DD')))) }}
                    />
                </Grid>
            </Grid>
        </>
    )
}
